import { render, staticRenderFns } from "./AlertLink.vue?vue&type=template&id=31ebd2b6&"
import script from "./AlertLink.vue?vue&type=script&lang=js&"
export * from "./AlertLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports